import { ToothFurcation } from '../../../../graphql/graphql';

export const FURCATION_OPTIONS = [
	{
		title: 'patientTreatment.meddiDENT.dentalCross.furcation.stage1',
		type: ToothFurcation.Stage_1,
	},
	{
		title: 'patientTreatment.meddiDENT.dentalCross.furcation.stage2',
		type: ToothFurcation.Stage_2,
	},
	{
		title: 'patientTreatment.meddiDENT.dentalCross.furcation.stage3',
		type: ToothFurcation.Stage_3,
	},
];
